export const STAFF_ROLES = ['admin', 'project_manager', 'production'];

export const isInternalUser = (user) => STAFF_ROLES.includes(user?.role);
export const canSeeSales = (user) => ['admin', 'project_manager'].includes(user?.role);
export const isAdmin = (user) => user?.role === 'admin';

// Legacy records have no creator metadata and are treated as admin-created.
// Non-admin team members may remove each other's newly-created team content,
// but never admin/client content.
export const canDeleteTeamContent = (user, record, roleField = 'createdByRole') => {
  if (isAdmin(user)) return true;
  return ['project_manager', 'production'].includes(record?.[roleField] || 'admin');
};
